export default __webpack_public_path__ + "static/media/estadosunidos.12d91423.svg";